/** Sorting for the Profit page detail tables (Vehicle / Job / Customer / Postcode). */

/** Parse table cell text for sort: money/pct/counts as numbers, else string. */
export function parseSortableCell(cell: string): number | string {
  const t = cell.trim();
  if (!t || t === '—') return '';
  const normalized = t
    .replace(/,/g, '')
    .replace(/£/g, '')
    .replace(/%/g, '')
    .replace(/^\+/, '')
    .replace(/^[−–—]/, '-');
  if (/^-?\d+(\.\d+)?$/.test(normalized)) {
    const n = Number(normalized);
    if (Number.isFinite(n)) return n;
  }
  return t.toLowerCase();
}

export function compareDetailCells(a: string, b: string): number {
  const av = parseSortableCell(a);
  const bv = parseSortableCell(b);
  if (typeof av === 'number' && typeof bv === 'number') return av - bv;
  if (typeof av === 'number') return -1;
  if (typeof bv === 'number') return 1;
  return String(av).localeCompare(String(bv), 'en-GB', { numeric: true, sensitivity: 'base' });
}

/**
 * Row order for sorting by `col`. Unknown cells (—, "No GPS") stay last in
 * both directions, so a "highest margin" sort never leads with rows whose
 * margin is unknown.
 */
export function sortDetailRowIndices(
  rows: string[][],
  col: number,
  direction: 'asc' | 'desc',
): number[] {
  const dir = direction === 'asc' ? 1 : -1;
  const indices = rows.map((_, i) => i);
  indices.sort((ai, bi) => {
    const a = rows[ai]?.[col] ?? '';
    const b = rows[bi]?.[col] ?? '';
    const aNum = typeof parseSortableCell(a) === 'number';
    const bNum = typeof parseSortableCell(b) === 'number';
    if (aNum !== bNum) return aNum ? -1 : 1;
    return dir * compareDetailCells(a, b);
  });
  return indices;
}
